// import React, { useState, useEffect } from 'react'
// // import logo1 from '../StudentRegristrationDesign/jain logo.png'
// import logo1 from '../'
// import { Popover, TextField, Typography } from '@mui/material'
// import { FaUserCircle } from 'react-icons/fa'
// import { AiOutlineLogout } from 'react-icons/ai'
// import { RiLockPasswordFill } from 'react-icons/ri'
// import { Col, Row, Spinner } from 'react-bootstrap'
// import { useNavigate } from 'react-router-dom'
// import './sidebar.css'

// const NavLogo = () => {
//   const memberId = sessionStorage.getItem('member_id')
//   const memberName = sessionStorage.getItem('memberName')
//   const email = sessionStorage.getItem('email')

//   useEffect(() => {
//     let sessionData = sessionStorage.getItem('email')
//     let flag = sessionStorage.getItem('flag')
//     if (!sessionData || !flag) {
//       navigate('/')
//     }
//   }, [])

//   let flag = Number(sessionStorage.getItem('flag'))

//   const [anchorEl, setAnchorEl] = React.useState(null)
  
//   const handleClickPopover = (event) => {
//     setAnchorEl(event.currentTarget)
//   }
//   const handleClosePopover = () => {
//     setAnchorEl(null)
//   }
//   const open2 = Boolean(anchorEl)
//   const id = open2 ? 'simple-popover' : undefined

//   const navigate = useNavigate()
//  const logoutFun = () => {
//   const confirmLogout = window.confirm("Are you sure you want to logout?");
//   if (confirmLogout) {
//     sessionStorage.clear();
//     navigate('/');
//   }
// };

//   const handlePasswordChange = () => {
//     navigate('/ChangePasswordAdmin')
//   }

//   return (
//     <>
//       <Row
//         className=" py-1 m-0 p-0 pe-2 py-3 nav-logo-fixed"
//         style={{ display: 'flex', backgroundColor: '#0783d6ff' }}
//       >
//         <Col
//           sm={8}
//           md={7}
//           lg={8}
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'start',
//           }}
//         >
//           {/* <img
//             src={logo1}
//             alt="Logo"
//             style={{ mixBlendMode: 'darken' }}
//             className="w-100"
//           />   */}
//           <span style={{fontSize:"24px",color:"white"}}>Sheth R. D. Davada Digambar Jain Boarding, Sangli.</span>
//         </Col>
//         <Col
//           sm={2}
//           md={5}
//           lg={4}
//           className="pe-0"
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'end',
//             fontSize:"18px",color:"white"
//           }}
//         >
//         {flag === 1
//             ? 'Admin(Main)'
//             : flag === 2
//             ? 'Superintendent'
//             : flag === 3
//             ? 'Office Attendant'
//             : flag === 4
//             ? 'Mess Attendant'
//             : null}
//             &nbsp;&nbsp;{' '}
//           <FaUserCircle
//             style={{ fontSize: 30, color: 'white',cursor:"pointer" }}
//             title="Profile"
//             aria-describedby={id}
//             variant="contained"
//             onClick={handleClickPopover}
//           />
//           <Popover
//             id={id}
//             open={open2}
//             anchorEl={anchorEl}
//             onClose={handleClosePopover}
//             anchorOrigin={{
//               vertical: 'bottom',
//               horizontal: 'left',
//             }}
//           >
//             <Typography>
//               {' '}
//               <button
//                 style={{
//                   backgroundColor: '#fff',
//                   color: 'black',
//                   borderRadius: '0px',
//                 }}
//                 className="text-end "
//                 onClick={handlePasswordChange}
//               >
//                 Change Password &nbsp; <RiLockPasswordFill />
//               </button>{' '}
//             </Typography>
//             <Typography className="w-100">
//               {' '}
//               <button
//                 style={{
//                   backgroundColor: '#fff',
//                   color: 'black',
//                   borderRadius: '0px',
//                 }}
//                 className="text-end w-100"
//                 onClick={logoutFun}
//               >
//                 Logout &nbsp;
//                 <AiOutlineLogout />
//               </button>{' '}
//             </Typography>
//           </Popover>
          
          
//         </Col>
//       </Row>
//     </>
//   )
// }

// export default NavLogo

import React, { useState, useEffect } from 'react'
import logo1 from '../StudentRegristrationDesign/jain logo.png'
import { Popover, Typography } from '@mui/material'
import { FaUserCircle } from 'react-icons/fa'
import { AiOutlineLogout } from 'react-icons/ai'
import { RiLockPasswordFill } from 'react-icons/ri'
import { Col, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import './sidebar.css'

const NavLogo = () => {
  const memberId = sessionStorage.getItem('member_id')
  const memberName = sessionStorage.getItem('memberName')
  const email = sessionStorage.getItem('email')

  const navigate = useNavigate()

  useEffect(() => {
    let sessionData = sessionStorage.getItem('email')
    let flag = sessionStorage.getItem('flag')
    if (!sessionData || !flag) {
      navigate('/')
    }
  }, [navigate])

  let flag = Number(sessionStorage.getItem('flag'))

  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClickPopover = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClosePopover = () => {
    setAnchorEl(null)
  }

  const open2 = Boolean(anchorEl)
  const id = open2 ? 'simple-popover' : undefined

  const logoutFun = () => {
    const confirmLogout = window.confirm('Are you sure you want to logout?')
    if (confirmLogout) {
      sessionStorage.clear()
      navigate('/')
    }
  }

  const handlePasswordChange = () => {
    navigate('/ChangePasswordAdmin')
  }

  return (
    <>
      <Row
        className="py-3 m-0 p-0 pe-2 nav-logo-fixed"
        style={{
          alignItems: 'center',
          backgroundColor: '#0783d6',
          color: 'white',
        }}
      >
        {/* LEFT SIDE — BOARDING NAME AND LOGO (MOBILE ONLY) */}
        <Col
          xs={12}
          md={7}
          lg={8}
          className="text-md-start text-center"

        >
          {/* MOBILE LOGO */}
          <div className="d-md-none mb-2">
            <img
              src={logo1}
              alt="Logo"
              style={{ height: '90px',backgroundColor:"#a2d6f8",borderRadius:"50%" }}
            />
          </div>

          {/* BOARDING NAME */}
          <span
            style={{
              fontSize: '20px',
              fontWeight: '500',
              lineHeight: '1.3',
            }}
          >
            Sheth R. D. Davada Digambar Jain Boarding, Sangli.
          </span>
        </Col>

        {/* RIGHT SIDE — USER ROLE AND PROFILE ICON */}
        <Col
          xs={12}
          md={5}
          lg={4}
          className="text-md-end text-center mt-2 mt-md-0 pe-0"
          style={{
            fontSize: '18px',
          }}
        >
          {flag === 1
            ? 'Admin(Main)'
            : flag === 2
            ? 'Superintendent'
            : flag === 3
            ? 'Office Attendant'
            : flag === 4
            ? 'Mess Attendant'
            : null}
          &nbsp;&nbsp;
          <FaUserCircle
            style={{ fontSize: 30, color: 'white', cursor: 'pointer' }}
            title="Profile"
            aria-describedby={id}
            onClick={handleClickPopover}
          />
          <Popover
            id={id}
            open={open2}
            anchorEl={anchorEl}
            onClose={handleClosePopover}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Typography>
              <button
                style={{
                  backgroundColor: '#fff',
                  color: 'black',
                  borderRadius: '0px',
                }}
                className="text-end"
                onClick={handlePasswordChange}
              >
                Change Password &nbsp; <RiLockPasswordFill />
              </button>
            </Typography>
            <Typography className="w-100">
              <button
                style={{
                  backgroundColor: '#fff',
                  color: 'black',
                  borderRadius: '0px',
                }}
                className="text-end w-100"
                onClick={logoutFun}
              >
                Logout &nbsp;
                <AiOutlineLogout />
              </button>
            </Typography>
          </Popover>
        </Col>
      </Row>
    </>
  )
}

export default NavLogo
